/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionType } from '@models/themeStudio.model';
import { ChartType } from '@models/chart.model';

@Component({
  selector: 'app-theme-option-elements-border-multi-gradiant',
  templateUrl: './theme-option-elements-border-multi-gradiant.component.html',
  styleUrls: ['./theme-option-elements-border-multi-gradiant.component.css']
})
export class ThemeOptionElementsBorderMultiGradiantComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() serieIndex: number;

  showDetails: boolean;
  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_borderMultiGradiant';

  constructor() {
    this.showDetails = false;
  }

  receiveValue(value: string, type?: ChartType) {
    this.themeOptions.setSeries(this.optionType, value, this.serieIndex, type ? [type] : undefined);
  }

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

}
